import { Location, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ish-auth0-sign-in',
  templateUrl: './auth0-sign-in.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslateModule, NgClass],
})
export class Auth0SignInComponent {
  private location = inject(Location);

  readonly signInClass = input<string>(undefined);

  get returnUrl() {
    return this.location.path();
  }
}
